export function pollUntil(fetchFn, isDone, { intervalMs = 2000, maxConsecutiveErrors = 3, onUpdate = () => {} } = {}) {
  let cancelled = false;
  let timer = null;
  let errors = 0;
  let resolvePromise;

  const promise = new Promise((resolve, reject) => {
    resolvePromise = resolve;
    const run = async () => {
      if (cancelled) return;
      try {
        const data = await fetchFn();
        if (cancelled) return;
        errors = 0;
        onUpdate(data);
        if (isDone(data)) {
          resolve(data);
          return;
        }
      } catch (err) {
        if (cancelled) return;
        errors += 1;
        if (errors >= maxConsecutiveErrors) {
          reject(err);
          return;
        }
      }
      timer = setTimeout(run, intervalMs);
    };
    run();
  });

  return {
    promise,
    cancel() {
      cancelled = true;
      clearTimeout(timer);
      resolvePromise(null);
    },
  };
}

export function isBatchFinished(summary) {
  return Boolean(summary) && summary.pending === 0 && summary.running === 0;
}
